<div class="pt-6">
  <aiwyn-logo [height]="60" [extraClasses]="'client-logo'" (click)="goBack()"></aiwyn-logo>
</div>

<div class="authentication-body custom-body">
  @let loginError = loginError$ | async;

  <h2>
    @if (loginError) {
      There was an issue signing in
    } @else {
      Sign in to {{ customerName$ | async }}
    }
  </h2>

  <p class="color-red-50 body-300 text-center mt-4">
    @if (loginError) {
      There was an issue with the sign in link {{ cachedEmailAddress$ | async }}. Please request a new one!
    } @else {
      The link you used is expired. Please request a new one.
    }
  </p>

  <form
    [formGroup]="emailSignInForm"
    name="emailSignInForm"
    novalidate
    class="w-100 mt-6"
  >

    <label class="body-400 color-gray-300 ta--left mb-2">Email address</label>

    <div class="position-relative w-100">
      <input
        formControlName="email"
        class="form-input pe-8"
        type="email"
        name="email"
        [class.form-input--invalid]="(emailSignInForm.controls.email.errors && canShowValidationErrors(emailSignInForm.controls.email)) || userEmailError()"
      />

      <div class="form-control__post-icon">
        <aiwyn-icon name="envelope"></aiwyn-icon>
      </div>
    </div>

    <mat-error *ngIf="(emailSignInForm.controls.email.errors && canShowValidationErrors(emailSignInForm.controls.email)) || userEmailError()">
      A valid email is required
    </mat-error>

    <button
      andButton
      color="primary"
      size="large"
      [isLoading]="isSubmissionProcessing$ | async"
      class="w-100 mt-6"
      (click)="signInWithEmailLink()"
    >
      Request a new magic sign-in link
    </button>
  </form>

  <ng-template #newActionBlock>
    <p class="body-300 color-gray-100 mt-4">
      We'll email you a link. Just click to sign-in.
    </p>
    <p class="body-300 color-gray-100">
      No password needed!
    </p>

    <div class="mt-8 mb-8 w-100 login__hr"><span>OR</span></div>

    <button
      andButton
      color="secondary"
      size="large"
      class="w-100"
      (click)="signInWithPassword()"
    >
      Sign in with a password
    </button>
  </ng-template>
</div>

<div>
  <p class="body-400 mt-6 color-gray-100 text-center mb-1">
    Want to pay a bill without signing in?
  </p>

  <div *ngIf="showGuestLogin()" class="d-flex justify-content-center">
    <button
      andButton
      color="hyperlink"
      class="p-0 fw-light"
      (click)="getClientKeyForAnonymousUser()"
      data-cy="guest-login"
    >
      Go to guest checkout
    </button>
  </div>
  <app-full-client-portal-footer class="mt-6"></app-full-client-portal-footer>
</div>
